import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'forms/rrf';
import { Button, Col, Row } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import MarketingPreferencesTable from './marketing-preferences-table';
import { getAdminMarketingCategories, updateAdminMarketingCategories } from '../../../actions/marketing-category';
import ArrowButton from '../../common/button-arrow';

const model = 'deep.admin_marketing_category';

class MarketingPreferences extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowNewCategoryInput: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAdminMarketingCategories());
  }

  handleAddCategoryOnClick = () => {
    this.setState({ isShowNewCategoryInput: true });
  };

  handleRemoveCategoryOnClick = () => {
    this.setState({ isShowNewCategoryInput: false });
  };

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(
      'deep.admin_marketing_category',
      updateAdminMarketingCategories(payload, this.handleRemoveCategoryOnClick)
    ));
  }

  render() {
    const { isLoading } = this.props;
    const { isShowNewCategoryInput } = this.state;

    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <PageTitle>Marketing Preferences</PageTitle>
          </Col>
        </Row>
        {isLoading ? 'Loading...' : (
          <div>
            <Row>
              <Col lg={12}>
                <Button
                  className="btn red-ghost-btn mg-lr-10 text-uppercase"
                  onClick={this.handleAddCategoryOnClick}
                >
                  New Category
                </Button>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <br />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Form model={model} onSubmit={this.handleSubmit}>
                  <MarketingPreferencesTable
                    model={model}
                    isShowNewCategoryInput={isShowNewCategoryInput}
                    handleRemoveCategoryOnClick={this.handleRemoveCategoryOnClick}
                  />
                  <Row>
                    <Col lg={12}>
                      <br />
                      <ArrowButton
                        className="btn red-ghost-btn mg-lr-10 text-uppercase float-end"
                      >
                        Save
                      </ArrowButton>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: !state.marketingCategories.fetched && state.marketingCategories.fetching
});

export default connect(mapStateToProps)(MarketingPreferences);
